import { useState } from "react";
import { ReportAPI } from "../../../../axios/api";
import { useAbortedEffect } from "../../../../components/hooks";
import moment from "moment";

import ModuleBlockLoading from "../../../../components/loading";
import { ModuleChartOverview } from "../../../../components/chart";

export default function ModuleCustomChartTotalOverview() {
  const [reload, setReload] = useState(true);
  const [apiData, setApiData] = useState({});

  useAbortedEffect(
    (signal) => {
      if (!reload) return;

      const params = {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
      };

      ReportAPI.getPowerOverview({
        options: { signal },
        data: params,
      }).then((result) => {
        let { Response, data } = result;

        if (Response === 1) {
          const totalEnergy = Number(data.totalEnergy) || 0;

          setApiData({
            isTenThousandUnit: totalEnergy > 30000,
            total_energy: totalEnergy,
            total_power: Number(data.totalPower) || 0,
            avg_factor: Number(data.avgFactor) || 0,
          });
          setReload(false);
        }
      });
    },
    [reload],
  );

  const formatData = [
    {
      label: `本月用電量`,
      value: apiData.total_energy
        ? Math.round(apiData.total_energy * 100) / 100
        : "-",
      unit: "kWh",
    },
    {
      label: `本月總功率`,
      value: apiData.total_power
        ? Math.round(apiData.total_power * 100) / 100
        : "-",
      unit: "kW",
    },
    {
      label: `本月平均功率因素`,
      value: apiData.avg_factor
        ? Math.round(apiData.avg_factor * 100) / 100
        : "-",
      unit: "",
    },
  ];

  return (
    <div className="relative">
      {reload && <ModuleBlockLoading />}
      <ModuleChartOverview data={formatData} />
    </div>
  );
}
